import type { Ecriture } from '@shared/types/Ecriture';

function yyyymmdd(date: string): string {
  const iso = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[1]}${iso[2]}${iso[3]}`;
  const fr = date.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (fr) return `${fr[3]}${fr[2]}${fr[1]}`;
  return date.replace(/\D/g, '').slice(0, 8);
}

function montant(n: number): string {
  return (Number.isFinite(n) ? n : 0).toFixed(2).replace('.', ',');
}

/**
 * Fichier des Écritures Comptables (tabulé), dérivé du format FEC français
 * et utilisable comme export OHADA gabonais en l'absence de spécification DGI dédiée.
 */
export function genererFec(ecritures: readonly Ecriture[]): string {
  const header = [
    'JournalCode',
    'JournalLib',
    'EcritureNum',
    'EcritureDate',
    'CompteNum',
    'CompteLib',
    'CompAuxNum',
    'CompAuxLib',
    'PieceRef',
    'PieceDate',
    'EcritureLib',
    'Debit',
    'Credit',
    'EcritureLet',
    'DateLet',
    'ValidDate',
    'Montantdevise',
    'Idevise',
  ].join('\t');
  const lignes = ecritures.map((e) => {
    const d = yyyymmdd(e.date);
    return [
      e.journal,
      e.journal,
      e.id,
      d,
      e.compte,
      e.libelle_compte ?? '',
      e.tiers_id ?? e.matricule ?? '',
      e.salarie ?? '',
      e.numero_piece ?? '',
      d,
      e.libelle,
      montant(e.debit),
      montant(e.credit),
      '',
      '',
      d,
      '',
      'XAF',
    ].join('\t');
  });
  return [header, ...lignes].join('\n');
}

export function genererJournalCsv(ecritures: readonly Ecriture[]): string {
  const header = [
    'Date',
    'Journal',
    'Compte',
    'Libellé',
    'Débit',
    'Crédit',
    'Pièce',
    'Source',
  ].join(';');
  const lignes = ecritures.map((e) =>
    [
      e.date,
      e.journal,
      e.compte,
      e.libelle,
      e.debit || '',
      e.credit || '',
      e.numero_piece ?? '',
      e.source,
    ].join(';'),
  );
  return [header, ...lignes].join('\n');
}

export function genererSyntheseCsv(
  comptes: ReadonlyArray<{ compte: string; libelle: string; debit: number; credit: number }>,
): string {
  const header = ['Compte', 'Libellé', 'Débit', 'Crédit', 'Solde'].join(';');
  const lignes = comptes.map((c) =>
    [c.compte, c.libelle, c.debit, c.credit, c.debit - c.credit].join(';'),
  );
  return [header, ...lignes].join('\n');
}
